export default __webpack_public_path__ + "static/media/alpheta-text-logo.8f380299.svg";